import moment from 'moment';
import User from 'sharedreact/data/User';

function _replaceCharsForCompare (value: string): string {
  return (
    value.replace('\'', '') // ' should be ignored
      .replace(/(_)|"/g, (_, a) => a ? '"' : '_') // database orders _ and " different so swap them to get same result
  );
}

function _compareEn (firstString: string, secondString: string): number {
  return _replaceCharsForCompare(firstString).localeCompare(_replaceCharsForCompare(secondString), 'en', {'sensitivity': 'base'});
}

function compareValues (value1: unknown, value2: unknown): number {
  if (!value1 && !value2) {
    return 0; // null == null
  } else if (!value2) {
    return 1; // value1 > null
  } else if (!value1) {
    return -1; // null < value2
  }

  if (moment.isMoment(value1) && moment.isMoment(value2)) {
    return (value1.isBefore(value2) ? -1 : (value1.isAfter(value2) ? 1 : 0));
  } else if (value1 instanceof User && value2 instanceof User) {
    return _compareEn(value1.name, value2.name);
  } else if (typeof value1 === 'number' && typeof value2 === 'number') {
    return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
  } else {
    return _compareEn(value1.toString(), value2.toString());
  }
}

function compareTableColumnEntries (value1: any, value2: any, sortAscending: boolean = true): number {
  const retval = compareValues(value1, value2);
  return sortAscending ? retval : -retval;
}

// compare 2 strings on unicode values
// equivalent to Java String.compareTo
function javaCompareTo (value1: string, value2: string): number {
  let valueIndex = 0;

  for (; valueIndex < value1.length && valueIndex < value2.length; valueIndex++) {
    const codePoint1: number = value1.codePointAt(valueIndex) ?? 0;
    const codePoint2: number = value2.codePointAt(valueIndex) ?? 0;

    if (codePoint1 !== codePoint2) {
      return codePoint1 < codePoint2 ? -1 : 1;
    }
  }

  return value1.length === value2.length ? 0 : value1.length < value2.length ? -1 : 1;
}

// compare 2 strings on unicode values but ignoring case differences
// equivalent to Java String.compareToIgnoreCase
function javaCompareToIgnoreCase (value1: string, value2: string): number {
  const value1LowerCase: string = value1.toLowerCase();
  const value2LowerCase: string = value2.toLowerCase();

  return javaCompareTo(value1LowerCase, value2LowerCase);
}

const CompareSupport = {
  compareValues,
  compareTableColumnEntries,
  javaCompareTo,
  javaCompareToIgnoreCase
};

export {
  compareValues,
  compareTableColumnEntries,
  javaCompareTo,
  javaCompareToIgnoreCase
};

export default CompareSupport;
